import { render } from "./MatrixScheduledPublish.vue?vue&type=template&id=ac5678e4&scoped=true"
import script from "./MatrixScheduledPublish.vue?vue&type=script&lang=js"
export * from "./MatrixScheduledPublish.vue?vue&type=script&lang=js"

import "./MatrixScheduledPublish.vue?vue&type=style&index=0&id=ac5678e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac5678e4"]])

export default __exports__